<template>
  <v-row class="ml-0 mb-4">
    <v-card-title class="font-weight-bold">Histórico</v-card-title>
    <v-expansion-panels>
      <v-expansion-panel
        v-for="versao_anterior in historico"
        :key="versao_anterior.id_caso_de_uso"
      >
        <v-expansion-panel-title>
          <v-row no-gutters>
            <v-col class="d-flex align-center justify-space-between">
              <span
                >{{ versao_anterior.identificador }} -
                {{ versao_anterior.nome }}</span
              >
              <span class="mr-2">{{
                new Date(versao_anterior.dt_cadastro).toLocaleDateString(
                  'pt-br',
                )
              }}</span>
            </v-col>
          </v-row>
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          <div>
            <div class="mb-1 text-grey-darken-2">
              <span class="text-grey-darken-4 font-weight-bold"
                >Storypoint: </span
              >{{ versao_anterior.storypoint }}
            </div>
            <div class="mb-1 text-grey-darken-2">
              <span class="text-grey-darken-4 font-weight-bold"
                >Prioridade: </span
              >{{ formataPrioridade(versao_anterior.prioridade) }}
            </div>
            <div class="mb-1 text-grey-darken-2">
              <span class="text-grey-darken-4 font-weight-bold">Gatilho: </span
              >{{ versao_anterior.gatilho }}
            </div>
            <div class="mb-1 text-grey-darken-2">
              <span class="text-grey-darken-4 font-weight-bold"
                >Pré-condição: </span
              >{{ versao_anterior.pre_condicao }}
            </div>
            <div class="mb-1 text-grey-darken-2">
              <span class="text-grey-darken-4 font-weight-bold"
                >Descrição: </span
              >{{ versao_anterior.descricao }}
            </div>
            <div class="mb-1 text-grey-darken-2">
              <span class="text-grey-darken-4 font-weight-bold"
                >Observações: </span
              >{{ versao_anterior.observacao }}
            </div>
          </div>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-row>
</template>

<script>
/**
 * @module HistoricoCSU
 * @desc Card que lista o historico de um CSU.
 * @vue-data {Array.<Object>} [historico=null] Lista com o historico.
 */
import axios from 'axios';

import store from '@/store/store';

const apiUrl = process.env.VUE_APP_API_URL;

export default {
  props: {
    csuID: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      historico: null,
    };
  },
  created() {
    this.getHistorico(this.csuID);
  },
  methods: {
    /**
     * Obtém p histórico do CSU pelo ID.
     *
     * @param {Number} id O id do caso de uso
     */
    async getHistorico(id) {
      try {
        axios
          .get(`${apiUrl}/api/v1/productBacklog/history/${id}`, {
            headers: {
              Authorization: `Bearer ${store.state.token}`,
            },
          })
          .then((res) => {
            this.historico = res.data.historyJson;
          });
      } catch (error) {
        console.log(error);
      }
    },
    /**
     * Formata a string 'MEDIA para 'Média'.
     *
     * @param {string} string - A string a ser formatada
     * @returns {string} A string formatada
     */
    formataPrioridade(prioridade) {
      if (prioridade === 'MEDIA') {
        return 'Média';
      }

      return prioridade.charAt(0) + prioridade.slice(1).toLowerCase();
    },
  },
};
</script>
